import { Divider, Typography } from "@material-ui/core";
import { useMain, useMainState } from "modules/app/contexts";
import React, { useEffect, useMemo, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { API } from "shared/services";
import { Container } from "./styles";
import { toast } from "react-toastify";
import { ArrowBackIos } from "@material-ui/icons";
import { UserForm } from "modules/app/components/UserForm";

function UsersEdit() {
  const { id } = useParams();
  const { users, user } = useMainState();
  const { updateMainUsers } = useMain();
  const history = useHistory();

  useEffect(() => {
    if (user?.role == "seller") {
      history.push("/app");
    }
  }, [user]);

  const userEdit = useMemo(() => users?.find((u) => u.id == id), [users]);

  if (!userEdit) return <></>;

  return (
    <Container>
      <Typography
        style={{
          fontWeight: "bold",
          fontSize: 22,
          display: "flex",
          justifyContent: "row",
          alignItems: "center",
        }}
      >
        <ArrowBackIos
          onClick={() => history.goBack()}
          className="icon-button"
        />
        Editar usuário {userEdit.name}
      </Typography>

      <Divider style={{ marginBottom: 30 }} />

      <UserForm userForm={userEdit} id={id} />
    </Container>
  );
}

export default UsersEdit;
